// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3U43g","content":"PrivacyPolicyPage_content__JFWw1"};